module.exports = __webpack_public_path__ + "img/45-l.f5139459.png";